/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/solicitud-pago/monto'

export default {
    getMontosTotal: (customfilter) => Api().get(`${route}?${customfilter}`) //montos totales con parametros
}
